import _ from 'lodash';
import React, { useContext, useEffect, useRef, useState } from 'react';

import { ChevronLeft } from 'react-bootstrap-icons';
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';

import './add_tx.component.css';
import { fetchBSDTxs, saveBSDTxs } from '../../../api';
import AppContext from '../../context';

import StepOne from './stepone/stepone.component';
import StepOneMob from './stepone/stepone_mob.component';
import StepTwo from './steptwo/steptwo.component';

const AddTx = (props) => {
  const context = useContext(AppContext);
  const { pfId, step, setStep, onSave, addtxFromRef } = props;
  const portfolio_id = pfId;

  // State
  const [isManual, setIsManual] = useState(true);
  const [txs, setTxs] = useState([]);
  const [bsdTxs, setBsdTxs] = useState([]);
  const [appliedBsdTxs, setAppliedBsdTxs] = useState([]);
  const [erroredBsdTxs, setErroredBsdTxs] = useState(null);
  const [showErroredBsdTxs, setShowErroredBsdTxs] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [invalid, setInvalid] = useState([]);
  const [txsFincode, setTxsFincode] = useState([]);
  // table overlay loader till fetchTransactions
  const [isLoaderVisible, setIsLoaderVisible] = useState(false);
  const fileUploadTemplate = useRef('tijori');

  // Group transactions by company
  const groupTxs = (transactions) => {
    const res = {};
    transactions.forEach((tx) => {
      if (!tx.fincode) return;
      if (!res[tx.fincode]) {
        res[tx.fincode] = {};
        res[tx.fincode].txs = [tx];
        res[tx.fincode].scrip = tx.scrip;
      } else {
        res[tx.fincode].txs.push(tx);
      }
      delete tx['fincode'];
    });
    return res;
  };

  const clubDuplicateTxs = (txs) => {
    return txs.reduce((result, tx) => {
      let idxInRes = result.findIndex((_tx) => {
        return (
          _tx.price === tx.price && _tx.date === tx.date && _tx.type === tx.type
        );
      });
      if (idxInRes != -1) {
        result[idxInRes].shares += tx.shares;
      } else {
        result.push(tx);
      }
      return result;
    }, []);
  };

  // Fetch B/S/D transactions for each company
  const fetchTransactions = async () => {
    setIsLoaderVisible(true);
    const txByCompanies = groupTxs(_.cloneDeep(txs));
    let bsdTransactions = [];
    let appliedBsdTxs = [];
    let erroredBsdTxs = [];
    const invalidComps = [];
    setInvalid(false);
    for (const fincode of Object.keys(txByCompanies)) {
      let _txs = txByCompanies[fincode].txs;
      const scrip = txByCompanies[fincode].scrip;
      try {
        if (isManual || fileUploadTemplate.current == 'tijori') {
          _txs = clubDuplicateTxs(_txs);
        }
        const res = await fetchBSDTxs(
          portfolio_id,
          {
            transactions: _txs,
            fincode,
            scrip,
            format: fileUploadTemplate.current,
          },
          'add',
        );
        const { transactions, total, meta, proceed } = res.data;
        bsdTransactions.push(transactions);
        if (total.has_sell_issue) {
          if (isManual) {
            invalidComps.push(_txs[0].company_name);
          } else {
            erroredBsdTxs.push({
              transactions,
              company: meta,
              amount: total.amount,
              total_shares: total.balance_shares,
            });
          }
        } else {
          appliedBsdTxs.push({
            transactions,
            company: meta,
            amount: total.amount,
            total_shares: total.balance_shares,
            proceed,
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
    if (invalidComps.length > 0) {
      setInvalid(invalidComps);
    } else {
      setBsdTxs(bsdTransactions);
      setAppliedBsdTxs(appliedBsdTxs);
      setErroredBsdTxs(erroredBsdTxs);
      if (!erroredBsdTxs.length) {
        setStep('addtx_two');
      }
    }
    setIsLoaderVisible(false);
  };

  // Remove a normal BUY/SELL transaction
  const removeTx = (idx) => {
    setTxs(txs.filter((_tx, i) => idx !== i));
    setTxsFincode(txsFincode.filter((_fincode, i) => idx !== i));
  };

  // Remove a B/S/D transaction
  const removeBsdTx = (idx_comp, idx_tx) => {
    const compTx = _.cloneDeep(bsdTxs[idx_comp]);
    compTx.transactions = compTx.transactions.filter((_tx, i) => idx_tx !== i);
    const cloneddBsdTxs = _.cloneDeep(bsdTxs);
    cloneddBsdTxs[idx_comp] = compTx;
    setBsdTxs(cloneddBsdTxs);
  };

  // Remove a B/S/D transaction and the applied transaction
  const removeAppliedBsdTx = (idx_comp, idx_tx) => {
    removeBsdTx(idx_comp, idx_tx);
    const compTx = _.cloneDeep(appliedBsdTxs[idx_comp]);
    compTx.transactions = compTx.transactions.filter((_tx, i) => idx_tx !== i);
    const clonedAppliedBsdTxs = _.cloneDeep(appliedBsdTxs);
    clonedAppliedBsdTxs[idx_comp] = compTx;
    setAppliedBsdTxs(clonedAppliedBsdTxs);
  };

  // Submit the chosen transactions to database
  const save = async () => {
    setShowError(false);
    setIsLoaderVisible(true);
    let clonedAppliedBsdTxs = _.cloneDeep(appliedBsdTxs);
    clonedAppliedBsdTxs = clonedAppliedBsdTxs.map((txObj) => {
      txObj.transactions = txObj.transactions.filter((tx) =>
        ['BUY', 'SELL'].includes(tx.type),
      );
      return txObj;
    });
    try {
      const res = await saveBSDTxs(portfolio_id, clonedAppliedBsdTxs);
      onSave();
    } catch (error) {
      setShowError(true);
      setErrorMessage(
        (error.response && error.response.data.message) ||
          'Cannot process request',
      );
      setIsLoaderVisible(false);
    }
  };

  useEffect(() => {
    if (window.innerWidth < 576) setIsMobile(true);
  }, []);

  const goBack = () => {
    if (!isManual) {
      setShowErroredBsdTxs(false);
    }
    setStep('addtx_one');
    setShowError(false);
    setErrorMessage('');
  };

  const setFileUploadTemplate = (template) => {
    fileUploadTemplate.current = template;
  };

  useEffect(() => {
    if (erroredBsdTxs && erroredBsdTxs.length) {
      setShowErroredBsdTxs(true);
    }
  }, [erroredBsdTxs]);

  return (
    <>
      <>
        {step === 'addtx_one' ? (
          !isMobile ? (
            <StepOne
              setStep={setStep}
              setTxs={setTxs}
              txs={txs}
              setBsdTxs={setBsdTxs}
              removeTx={removeTx}
              txsFincode={txsFincode}
              setTxsFincode={setTxsFincode}
              invalidComps={invalid}
              setInvalidComps={setInvalid}
              isLoaderVisible={isLoaderVisible}
              erroredBsdTxs={erroredBsdTxs}
              setErroredBsdTxs={setErroredBsdTxs}
              showErroredBsdTxs={showErroredBsdTxs}
              setShowErroredBsdTxs={setShowErroredBsdTxs}
              isManual={isManual}
              setIsManual={setIsManual}
              setFileUploadTemplate={setFileUploadTemplate}
              pfName={context.portfoliosById[pfId].name}
              pfId={pfId}
            />
          ) : (
            <StepOneMob
              setStep={setStep}
              setTxs={setTxs}
              txs={txs}
              setBsdTxs={setBsdTxs}
              removeTx={removeTx}
              invalidComps={invalid}
              pfName={context.portfoliosById[pfId].name}
            />
          )
        ) : (
          <StepTwo
            setStep={setStep}
            txs={appliedBsdTxs}
            removeAppliedBsdTx={removeAppliedBsdTx}
            isMobile={isMobile}
            showError={showError}
            errorMessage={errorMessage}
            isLoaderVisible={isLoaderVisible}
            pfName={context.portfoliosById[pfId].name}
          />
        )}
      </>
      <div className="modal-footer">
        {step === 'addtx_one' && (
          <>
            {!props.emptyPfs && (
              <Button
                size="sm"
                onClick={() => {
                  if (props.isWebview) {
                    window.Android.goBack();
                    return;
                  }
                  if (showErroredBsdTxs) {
                    setShowErroredBsdTxs(false);
                    return;
                  }
                  setStep(addtxFromRef);
                }}
                variant=""
                className="mr-auto back-button"
              >
                <ChevronLeft /> <span>back</span>
              </Button>
            )}
            {!isMobile ? (
              <span className="footer-text">
                Proceed to Step 2 to view all transactions including splits &
                bonuses
              </span>
            ) : (
              <span className="footer-text">
                Proceed to Step 2 to view transaction including splits & bonuses
              </span>
            )}
            {txs.length < 1 ? (
              <OverlayTrigger
                key={'step-one-next-btn-tooltip'}
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={
                  <Tooltip id="step-one-tooltip">
                    Add at least one transaction to proceed
                  </Tooltip>
                }
              >
                <Button
                  size="sm"
                  onClick={() => {
                    if (txs.length > 0) {
                      fetchTransactions();
                    }
                  }}
                  variant="success"
                  className="next-btn"
                  disabled={txs.length < 1 || isLoaderVisible}
                >
                  Next
                </Button>
              </OverlayTrigger>
            ) : (
              <Button
                size="sm"
                onClick={() => {
                  if (showErroredBsdTxs) {
                    setStep('addtx_two');
                    return;
                  }
                  if (txs.length > 0) {
                    fetchTransactions();
                  }
                }}
                variant="success"
                className="next-btn"
                disabled={txs.length < 1 || isLoaderVisible}
              >
                {showErroredBsdTxs ? 'Ignore & Proceed' : 'Next'}
              </Button>
            )}
          </>
        )}
        {step === 'addtx_two' && (
          <>
            <Button
              size="sm"
              onClick={() => goBack()}
              variant=""
              className="mr-auto back-button"
            >
              <ChevronLeft /> <span>back</span>
            </Button>
            <span className="footer-text">
              All future corporate actions will be automatically incorporated
              into the portfolio
            </span>
            <Button
              size="sm"
              onClick={() => save()}
              variant="success"
              className="next-btn"
              disabled={isLoaderVisible}
            >
              Save
            </Button>
          </>
        )}
      </div>
    </>
  );
};

export default AddTx;
